/**
 * Import Dependency
 */
import { library } from '@fortawesome/fontawesome-svg-core'

/**
 * Import Icons
 */
import {
  faDollarSign,
  faGlobeAmericas,
  faArrowRight,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'

/**
 * Create Customize Library
 */
library.add(
  faDollarSign,
  faGlobeAmericas,
  faArrowRight,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
)



// WEBPACK FOOTER //
// ./src/fonts/index.js